import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
export default action('showFindFavoritesPicker')(function showFindFavoritesPicker(shouldShow) {
    store.mailFavoritesViewState.shouldShowFindFavoritesPicker = shouldShow;
});
//# sourceMappingURL=showFindFavoritesPicker.js.map